<template>

  <div>
    <my-header> </my-header>
    <div class="mainWrap">
      <div class="main">
        <div class="breadCrumbs">
          <h3>支付中心</h3>
          <span>
            <router-link to="/">
              <a>首页</a> &gt;
            </router-link>
            <!--  <a @click="product()">产品</a> -->
            <a title=""
                           href="http://shop.qdc.com/member/productorder.html">{{odercenter}}</a>&gt;
            <em>支付中心</em>
          </span>
        </div>
        <!--内容开始-->
        <div class="content">

          <div class="shopp-content">

            <div class="shopping">

              <form id="formOrder"
                    action=""
                    method="post"
                    v-if="payshow">
                <div class="pay">
                  <h3>支付方式：</h3>
                  <p><input type="radio"
                           name="radio1"
                           checked="checked" /><span>在线支付：</span>微信平台的支付方式。请使用微信扫一扫，扫描二维码支付。</p>
                  <ul>
                    <li v-for="items in paylist"
                        :key="items.id"
                        v-bind:style="{backgroundImage:'url(' + items.backgroundImage + ')'}">
                      <input type="radio"
                             name="pay"
                             checked="checked" />
                    </li>

                    <div class="del_float"></div>
                    <div class="paycode">
                      <div class="codeinfo fl">
                        <h3 style="text-align: center;">应付总额：<span> ￥{{AllSum|toFixed(2)}}</span></h3>
                        <div id="qrcode"
                             ref="qrcode"
                             class="qrcode"> </div>
                        <div class="info">
                          <img src="../assets/icon-red.png"
                               alt="" />
                          <span>请使用微信扫一扫<br />扫描二维码支付</span>
                        </div>
                      </div>
                      <div class="pic fr"><img src="../assets/phone-bg1.png"
                             alt="" /></div>
                    </div>
                    <!-- <div class="paycode" >
                         <div id="qrcode" ref="qrcode" class="qrcode"> </div>
                         <span> 请打开手机进行{{payname}}</span>
                         </div> -->
                  </ul>

                </div>

              </form>
              <div class="pay-wrap clearfix">
                <!-- 支付失败 -->
                <div class="suc-pay"
                     v-if="failpay">
                  <img alt=""
                       src="../assets/icon-fail.png">
                  <h4>支付失败!</h4>
                  <p>请重新支付</p>
                  <div class="suc-pay-btn clearfix">
                    <ul>
                      <li><a @click="purchase()">取消支付</a></li>
                      <li class="cur">
                        <a @click="newpay()">重新支付</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 支付成功 -->
                <div class="suc-pay"
                     v-if="sucpay">
                  <img alt=""
                       src="../assets/icon-suc.png">
                  <h4>支付成功!</h4>
                  <p>订单金额：<span>￥{{AllSum|toFixed(2)}}</span></p>
                  <div class="suc-pay-btn clearfix">
                    <ul>
                      <li><a title=""
                           href="http://shop.qdc.com/member/productorder.html">查看订单</a></li>
                      <li class="cur">
                        <a title=""
                           @click="purchase()">继续购买</a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>
        <!--内容结束-->

      </div>
    </div>

    <!-- 
    <div class="qrcodebg">
    <div class="qrcodebox">
    <div id="qrcode" ref="qrcode">
      
    </div>
    </div>
    </div> -->

  </div>

</template>
<script>
import QRCode from 'qrcodejs2'
import { mapActions, mapGetters } from "vuex";
import VDistpicker from "v-distpicker";
import myHeader from "@/views/detailimg";
import { getregxx, gettjddxx, getregcs, getregqx, wxpdpay,sjpayif ,gzkxx} from "@/api/api";
export default {
  components: { myHeader, VDistpicker },
  data () {

    return {
        
      payshow: true,
      failpay: false,
      sucpay: false,
      orderid: '',
      payname: '',
      oderimg: '',
      httpurl: "http://shop.qdc.com/",
      daohang: false, //显示导航
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      odercenter: "订单中心",
      message: {
        Consignee: "",
        area: {
          province: '',
          city: "",
          dist: ""
        },
        address: "",
        tel: "",
        pay: '',
      },
      provinceList: [

      ],
      cityList: [

      ],
      distList: [],
      paycodeimg: false,
      paylist: [
        // {
        //   id: 1,
        //   name: '支付宝',
        //   backgroundImage: require("../assets/cr_qlpic11.jpg"),
        // },
        {
          id: 2,
          name: '微信',
          backgroundImage: require("../assets/cr_qlpic12.jpg"),
        },
      ],
      provinceSelected: "",
      addinfo: {
        elseask: "",
        name: "",
        quality: "",
        style: ""
      },
      YwwpicRight: {
        imageid: '',
      },
      YwwLagre: {
        imageid: '',
      },
      Baozhuang: {
        id: '',
      },
      Xiancai: {
        id: '',
      },
      lcolorid: '',
      iscolor: '',
      codeurl: '',
      ukey: 0
    };
  },

  computed: {
  },
  created () {
     if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      }else{
          this.ukey=localStorage.getItem('newukey')
      }
//    if (localStorage.getItem("zhprice") != null) {
//       var zhprice = JSON.parse(localStorage.getItem('zhprice'));
//       this.AllSum = zhprice
//     } else {
//       this.AllSum =this.$route.query.DesignSumPrice
//     }
 if(this.$route.query.DesignSumPrice) {
      this.AllSum = this.$Base64.decode(this.$route.query.DesignSumPrice)
    }
if (localStorage.getItem("zhprice") != null) {
    if(!this.$route.query.type){
 var zhprice = JSON.parse(localStorage.getItem('zhprice'));
      this.AllSum = zhprice
    }
     
    } 
   
    this.orderid = this.$route.query.orderid
    this.paymsg();
   
    this.timer = (setInterval(this.paymsg, 10 * 1000));
    
    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;

  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {
    this.qrcodeScan();    // 注：需在mounted里触发qrcodeScan函数

  },
  methods: {

    newpay () {
      this.payshow = true
      this.failpay = false
      this.sucpay = false
    },
     
    paymsg () {

      var self = this;
      var para = {
        ddbh: this.orderid,
      };
    //   console.log(para);
if(this.$route.query.type==1){
      sjpayif(para).then(res => {
        // console.log("", res.data);
        if (res.data.error_code == 200) {
          this.payshow = false
          this.sucpay = true
        }

        res => {
          console.info("调用失败", res);
        };
      });
}else{
  wxpdpay(para).then(res => {
        // console.log("", res.data);
        if (res.data.error_code == 200) {
          this.payshow = false
          this.sucpay = true
        }

        res => {
          console.info("调用失败", res);
        };
      });
}
    
    },
    qrcodeScan () {//生成二维码
    if(this.$route.query.codeurl){
     let qrcode = new QRCode('qrcode', {
        width: 200,  // 二维码宽度 
        height: 200, // 二维码高度
        text: this.$route.query.codeurl
      })
    }else{
       this.payshow=false
       this.sucpay = true
      }
    },
    purchase () {
      this.$router.push({
        path: '/MixedCellSeries',


      });
    }
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
.distpicker-address-wrapper /deep/ select {
  float: left;
  padding-left: 15px;
  color: #999;
  font-size: 15px;
  padding: 0px;
  font-family: "微软雅黑";
  width: 171px;
  height: 30px;
  background: #252733 no-repeat right 11px;
  /* -webkit-appearance: none; */
  /* resize: none; */
  border: none;
}
.paycode {
  display: flow-root;
  position: relative;
  height: auto;
  margin: 10px 0;
  padding: 0 20px;
  border: 1px solid #d3d3d3;
}
.qrcode {
  padding: 20px;
  margin: 5px 0;
  border: 1px solid #d3d3d3;
}

.codeinfo {
  margin: 20px;
}

.pay-modeitem h3 {
  font-size: 16px;
  color: #666;
  line-height: 30px;
  margin-bottom: 10px;
}
.info {
  background: #ff7674;
  text-align: center;
  /* width: 42%; */
  margin: 15px auto 0px;
  padding: 5px 10px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.info img {
  display: inline-block;
  margin-right: 10px;
}
.info span {
  display: inline-block;
  font-size: 12px;
  color: #fff;
  line-height: 20px;
  text-align: left;
}
.pic {
  padding: 20px 0;
  display: block;
  /* width: 58%; */
  text-align: center;
  margin: 0px auto;
}
.pay-wrap {
  width: 100%;
  margin-bottom: 80px;
}
.suc-pay {
  width: 100%;
  background: #2e3442;
  overflow: hidden;
  padding: 50px 0px 80px 0;
  margin: 20px auto;
}
.suc-pay img {
  display: block;
  width: 88px;
  margin: 20px auto 8px auto;
}
.suc-pay h4 {
  width: 100%;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 8px;
  font-family: "微软雅黑", "sans-serif";
  line-height: 32px;
}
.suc-pay p {
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
  font-family: "微软雅黑", "sans-serif";
  line-height: 20px;
}
.suc-pay p span {
  color: #ef456c;
  font-weight: bold;
}
.suc-pay ul {
  text-align: center;
}
.suc-pay li {
  display: inline-block;
  width: 120px;
  height: 42px;
  margin-left: 12px;
  margin-right: 12px;
  border: 1px #5e6168 solid;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  border-radius: 4px;
  font-family: "微软雅黑", "sans-serif";
}
.suc-pay li a {
  display: block;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  font-family: "微软雅黑", "sans-serif";
}
.suc-pay li.cur {
  border: #2da0f7 solid 1px;
  background: #2da0f7;
}
</style>


// WEBPACK FOOTER //
// src/views/pay.vue